module.exports = __webpack_public_path__ + "static/media/spotify-api-clone.2765c3b6.md";